import { render, staticRenderFns } from "./EducationRecord.vue?vue&type=template&id=f00e5154&scoped=true"
import script from "./EducationRecord.vue?vue&type=script&lang=js"
export * from "./EducationRecord.vue?vue&type=script&lang=js"
import style0 from "./EducationRecord.vue?vue&type=style&index=0&id=f00e5154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00e5154",
  null
  
)

export default component.exports